export const IdTypes = [
    { "key": "DNI", "text": "DNI/NIF", "value": "DNI" }, 
    { "key": "NIE", "text": "NIE", "value": "NIE" },
    { "key": "OTHER", "text": "OTROS", "value": "OTHER" }]